import React from 'react';
import TableManager from '../components/data/TableManager';

const columnConfig = [
  "GAB_Id_GruppiAbilitazioni=1,ID",
  "GAB_Codice=2,Codice",
  "GAB_Descrizione=2,Descrizione",
  "GAB_Ordinamento=2,Ordinamento,type=number",
  "GAB_NomeGruppo=2,Nome Gruppo",
  "GAB_InizioValidita=1,Inizio Validità,type=datetime",
  "GAB_FineValidita=1,Fine Validità,type=datetime",
  "GAB_StatoRecord=2,Stato Record", // Lookup
  "GAB_Utente=0,Utente Audit",
  "GAB_Terminale=0,Terminale Audit",
  "GAB_Timestamp=0,Timestamp DB"
];

const filterConfig = [
  { field: 'GAB_Codice', label: 'Codice', type: 'text' },
  { field: 'GAB_Descrizione', label: 'Descrizione', type: 'text' },
  { field: 'GAB_NomeGruppo', label: 'Nome Gruppo', type: 'text' },
  { field: 'GAB_StatoRecord', label: 'Stato Record', type: 'lookup', lookupName: 'statiRecordChar' },
];

const lookupConfig = {
  statiRecordChar: {
    options: [
      { value: 'A', label: 'Attivo' },
      { value: 'S', label: 'Sospeso' },
      { value: 'D', label: 'Disattivo' },
    ],
  }
};

const inputTypes = {
  GAB_Descrizione: 'textarea',
  GAB_Ordinamento: 'number',
  GAB_InizioValidita: 'datetime-local',
  GAB_FineValidita: 'datetime-local',
};

const GruppiAbilitazioniPage = () => {
  return (
    <TableManager
      tableName="DOM_GruppiAbilitazioni"
      primaryKey="GAB_Id_GruppiAbilitazioni"
      pageTitle="Gestione gruppi abilitazioni"
      columnConfig={columnConfig}
      filterConfig={filterConfig}
      lookupConfig={lookupConfig}
      inputTypes={inputTypes}
      enableCreate={true}
      enableEdit={true}
      enableDelete={true}
    />
  );
};

export default GruppiAbilitazioniPage;